import { render, staticRenderFns } from "./OrgListNode.vue?vue&type=template&id=2e0783ad&scoped=true"
import script from "./OrgListNode.vue?vue&type=script&lang=js"
export * from "./OrgListNode.vue?vue&type=script&lang=js"
import style0 from "./OrgListNode.vue?vue&type=style&index=0&id=2e0783ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0783ad",
  null
  
)

export default component.exports